import { i18n } from '@/shared/i18n'

/**
 * Backend timestamps are RFC3339 strings. Every screen renders them through
 * these three, so the locale and the shape stay consistent panel-wide.
 */

const asDate = (value: string | Date): Date => (value instanceof Date ? value : new Date(value))

export function formatDate(value: string | Date): string {
  return new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium' }).format(asDate(value))
}

export function formatDateTime(value: string | Date): string {
  return new Intl.DateTimeFormat(i18n.language, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(asDate(value))
}

type RelativeStep = { limit: number; divisor: number; unit: Intl.RelativeTimeFormatUnit }

const YEAR_STEP: RelativeStep = { limit: Infinity, divisor: 31_536_000, unit: 'year' }

const RELATIVE_STEPS: RelativeStep[] = [
  { limit: 60, divisor: 1, unit: 'second' },
  { limit: 3_600, divisor: 60, unit: 'minute' },
  { limit: 86_400, divisor: 3_600, unit: 'hour' },
  { limit: 2_592_000, divisor: 86_400, unit: 'day' },
  { limit: 31_536_000, divisor: 2_592_000, unit: 'month' },
]

/** «5 минут назад» for feeds. */
export function formatRelative(value: string | Date, now: Date = new Date()): string {
  const seconds = Math.round((asDate(value).getTime() - now.getTime()) / 1000)
  const elapsed = Math.abs(seconds)

  const step = RELATIVE_STEPS.find(({ limit }) => elapsed < limit) ?? YEAR_STEP

  return new Intl.RelativeTimeFormat(i18n.language, { numeric: 'auto' }).format(
    Math.trunc(seconds / step.divisor),
    step.unit,
  )
}
